import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import "./CustomTable.scss";
import contentParserOptions from "../../utils/parser";

const CustomTable = ({ tableComp }) => {
  return (
    <div className="custom-table">
      {parse(tableComp, contentParserOptions)}
    </div>
  );
};

CustomTable.propTypes = {
  tableComp: PropTypes.string,
};

export default CustomTable;
